import { Types } from 'mongoose';
import { z } from 'zod';

export const UpdateConversationKeywordsSchema = z.object({
  keywords: z.array(z.string()),
});

export const ConversationKeywordSchema = z.object({
  _id: z.union([z.instanceof(Types.ObjectId), z.string()]),
  keyword: z.string(),
  companyId: z.string(),
  createdBy: z.string(),
});

export const UpdateConversationKeywordsResponseSchema = z.object({
  conversationId: z.string(),
  keywords: z.array(z.string()),
  upsertedKeywords: z.array(ConversationKeywordSchema),
});

export const KeywordBodySchema = z.object({
  keyword: z.string().min(1).max(50),
});
